<template>
<div class="menu-item-r">
  <div class="mail">
    <div class="v-nav-wrap">
      <div class="op-select-view" v-if="false">
        <el-badge :is-dot="newMessageComing" class="coming">
          <el-button :class="{ 'el-button--primary': value === 'chat', 'el-button--primary-empty': value !== 'chat' }" type="primary" size="small" @click="changeFn('chat')">{{$t('notification')}}</el-button>
        </el-badge>
        <el-badge :is-dot="newMailComing" class="coming">
          <el-button :class="{ 'el-button--primary': value === 'mail', 'el-button--primary-empty': value !== 'mail' }" type="primary" size="small" @click="changeFn('mail')">{{$t('messageMail')}}</el-button>
        </el-badge>
      </div>
    </div>
    <div class="mailBox">
      <div class="mailBoxL">
        <div class="mailT">{{$t('Messag List')}}</div>
        <el-menu
          default-active="1"
          class="el-menu-vertical"
        >
          <el-menu-item index="1" @click="getNoticeList('INVITE', 1)">
            <i class="el-icon-bell"></i>
            <span slot="title">
              <el-badge :is-dot="!inviteSeen">{{$t('mail.INVITE')}}</el-badge>
            </span>
          </el-menu-item>
          <el-menu-item index="2" @click="getNoticeList('CHECKRESULT', 1)">
            <i class="el-icon-bell"></i>
            <span slot="title">
              <el-badge :is-dot="!checkresultSeen">{{$t('mail.CHECKRESULT')}}</el-badge>
            </span>
          </el-menu-item>
          <el-menu-item index="3" @click="getNoticeList('SPONSOR', 1)">
            <i class="el-icon-bell"></i>
            <span slot="title">
              <el-badge :is-dot="!sponsorSeen">{{$t('mail.SPONSOR')}}</el-badge>
            </span>
          </el-menu-item>
          <el-menu-item index="4" @click="getNoticeList('INTENTIONORDER', 1)">
            <i class="el-icon-bell"></i>
            <span slot="title">
              <el-badge :is-dot="!intentionorderSeen">{{$t('mail.INTENTIONORDER')}}</el-badge>
            </span>
          </el-menu-item>
          
        </el-menu>
      </div>
      <div class="mailBoxR">
        <div class="mailT">{{$t('mail.'+this.noticeType+'')}}</div>
        <div class="mailBoxRContent">
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item v-for="item in collapseObj"  @click.native="getNotice(item)" :key="item.id" :name="item.id">
                <template slot="title">
                  <div :class="item.seen ? 'seen' : 'noSeen'">{{getText(item.content)}}</div>
                </template>
              <div>{{item.createTime | formatDate('all')}}</div>
              <div>{{getText(item.content)}}</div>
            </el-collapse-item>
          </el-collapse>
          
        </div>
        <div class="bl-container">
          <el-pagination
            v-if="collapseObj.length > 0"
            background
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :current-page.sync="pageNum"
            :total="total"
            class="bl-page"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapState } from 'vuex'
import { timMixin } from '@/mixins/timMixins.js'
import { 
  noticeListType 
  ,noticeList
  ,noticeGetNotice 
  } from '@/api/index'
export default {
  mixins: [timMixin],
  data() {
    return {
      value: 'mail',
      activeNames: [],
      noticeListArr: [],
      noticeType: '',
      pageNum: 1,
      total: 1000,
      inviteSeen: true,
      checkresultSeen: true,
      sponsorSeen: true,
      intentionorderSeen: true,
      contentTitle: '',
      timer: null,
      seen: '',
      collapseObj: []
    }
  },
  components: {},
  computed: {
    ...mapState({
      newMessageComing: state => state.timStore.newMessageComing,
      newMailComing: state => state.timStore.newMailComing,
    }),
  },

  async mounted() {
      console.log(this.$route)
      if (this.$route.query.rName) {
          setTimeout(async ()=>{
              await this.openChatDialog()
          },1000)
      }
      this.getList()
      this.getNoticeList('INVITE', 1)
      this.timer = setInterval(() => {
          // 定时器操作
          this.getList()
      }, 5000)
  },
  beforeDestroy() {
    clearInterval(this.timer);        
    this.timer = null;
  },
  methods: {
    changeFn(value) {
      this.value = value
      this.$router.push('/' + value)
    },
    handleChange() {
      // console.log(val)
    },
    getNotice(data) {
        let params = {
          id: data.id
        }
        noticeGetNotice(params)
          .then(() => {
            data.seen = true
            this.getList()
          })
    },
    getNoticeList(val, pageNum) {
      this.noticeType = val
      let params = {
        noticeType: this.noticeType,
        pageNum: pageNum
      }
      noticeList(params)
        .then(res => {
          this.collapseObj = res.data.data.list || []
          this.total = res.data.data.total
        })
    },
    getList() {
      noticeListType({})
        .then(res => {
          this.noticeListArr = res.data.data || []
          if (this.noticeListArr.length > 0) {
            for (let i in this.noticeListArr) {
              if (this.noticeListArr[i]['noticeType'] == 'SPONSOR') {
                this.sponsorSeen = this.noticeListArr[i]['seen']
              }
              if (this.noticeListArr[i]['noticeType'] == 'CHECKRESULT') {
                this.checkresultSeen = this.noticeListArr[i]['seen']
              }
              if (this.noticeListArr[i]['noticeType'] == 'INVITE') {
                this.inviteSeen = this.noticeListArr[i]['seen']
              }
              if (this.noticeListArr[i]['noticeType'] == 'INTENTIONORDER') {
                this.intentionorderSeen = this.noticeListArr[i]['seen']
              }
            }
            //  && this.intentionorderSeen
            if(this.inviteSeen && this.sponsorSeen && this.checkresultSeen && this.intentionorderSeen) {
              this.$store.commit('setNewMailStatus', false)
            } else {
              this.$store.commit('setNewMailStatus', true)
            }
          }
          
        })
    },
    handleCurrentChange(page) {
      this.getNoticeList(this.noticeType, page)
    },
    getText(txt) {
        txt = txt.replace(/<[^>]+>/g, '')
        txt = txt.replace(/&nbsp;/gi, '')
        return txt
    }
  }
}
</script>
<style lang="stylus" >
.coming{
  margin-right: 10px;
}
.noSeen{
  width 100px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.seen{
  color $color-gray-cc
  width 100px;
  font-weight bold;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.el-menu-vertical{
  border-right: solid 1px $color-white;
}
.el-menu-vertical .el-badge__content.is-dot{
  top: 13px !important;
  left: -44px !important;
}
.mail {
  padding-left: 15px;
  margin-bottom: 30px;
  width: 100%
  .mailBox {
    display: flex;
    .mailT {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: $color-main;
      color $color-white
    }
    .mailBoxL {
      width: 266px;
      background: $color-white;
      font-size: 16px;
      
      .num {
        float: right;
        width: 20px;
        height: 20px;
        display: inline-block;
        background: red;
        line-height: 22px;
        text-align: center;
        position: relative;
        top: 18px;
        border-radius: 20px;
        color: $color-white;
      }
      .mailBoxDiv {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
      }
    }

    .mailBoxR {
      width: 1090px;
      margin: 0 0 0 10px;
      background: $color-white;

      >>>.el-collapse {
        margin: 0 10px;
      }
      .mailBoxRContent{
        padding: 0 20px;
      }
    }
    .bl-container{
      margin 20px 0  
    }
  }
}
</style>
